import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { PETRUSMA_PROPERTY_META } from "./meta.ts";
import { buildSearchUrl } from "./runtime.ts";

export * from "./meta.ts";
export * from "./runtime.ts";

export const PETRUSMA_PROPERTY_ADAPTER = defineSoldOnlyAdapter(
  PETRUSMA_PROPERTY_META,
  buildSearchUrl,
  {
    // Direct fetch served its search and detail pages in full (probe, 2026-10-14).
    directFirst: true,
  },
);
